import { BoxSelectProductsModalViewType } from '../../types/view/BoxSelectProductsModalViewType';
import { CommonModal } from '../CommonModal';
import { SubscriptionProductItem } from '../../utils/subscriptionDetail/types';
import { useState } from 'react';
import styles from '../../assets/scss/BoxProductModal/BoxSelectProductsModal.module.scss';
import commonModalClass from '../../assets/scss/CommonModal.module.scss';
import { QuantitySelect } from '../QuantitySelect/QuantitySelect';

type Props = {
  active: boolean;
  closeFunc: () => void;
  modal: BoxSelectProductsModalViewType;
  onClickOk: (items: SubscriptionProductItem[], quantities: Record<string, number>) => void;
};

export function BoxSelectProductsModal({ active, closeFunc, modal, onClickOk }: Props) {
  const [quantities, setQuantities] = useState<Record<string, number>>({ ...modal.quantities });

  const onChange = (id: string, newQuantity: number) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: newQuantity,
    }));
  };

  const onClickBoxUpdates = () => onClickOk(modal.items, quantities);

  let totalQuantity = 0;
  let subtotal = 0;
  let discount = 0;
  for (const item of modal.items) {
    const quantity = quantities[item.id] ?? 0;
    totalQuantity += quantity;
    subtotal += item.currentPriceAmount * quantity;
    discount += (item.originPrice - item.currentPriceAmount) * quantity;
  }
  const isDisabled = totalQuantity < modal.minQuantity;

  const showDiscountClass = !isDisabled ? styles.showDiscount : '';

  const content = (
    <div className={styles.container}>
      <p className={styles.percent}>＼通常価格より{modal.percent}%OFF／</p>
      <p className={styles.title}>{modal.title}</p>
      <div className={styles.textArea}>
        <p className={styles.text}>{modal.text}</p>
      </div>

      <div className={styles.products}>
        {modal.items.map((p) => (
          <ProductItem
            key={p.id}
            product={p}
            quantity={quantities[p.id]}
            onChange={onChange}
          />
        ))}
      </div>

      <div className={styles.totals}>
        <div className={`${styles.summaryRow} ${showDiscountClass}`}>
          <div className={styles.quantity}>
            <span className={styles.label}>数量</span>
            <span className={styles.value}>{totalQuantity}</span>
          </div>

          <div className={styles.subtotals}>
            <div
              className={styles.discount}
              style={{ visibility: !isDisabled ? 'visible' : 'hidden' }}
            >
              通常より <span className={styles.value}>¥{discount.toLocaleString()}</span>オトク
            </div>

            <div className={styles.subtotal}>
              <span className={styles.label}>小計</span>
              <span className={styles.currency}>¥</span>
              <span className={styles.value}>{subtotal.toLocaleString()}</span>
            </div>
          </div>
        </div>
      </div>

      <div className={commonModalClass.btnContainer}>
        <button
          className={commonModalClass.btnPrimary}
          onClick={onClickBoxUpdates}
          disabled={isDisabled}
        >
          この内容でセットする
        </button>

        <button
          className={commonModalClass.btnLink}
          onClick={closeFunc}
        >
          閉じる
        </button>
      </div>
    </div>
  );

  return (
    <CommonModal
      active={active}
      closeFunc={closeFunc}
    >
      {content}
    </CommonModal>
  );
}

type ProductItemProps = {
  product: SubscriptionProductItem;
  quantity: number;
  onChange: (id: string, newQuantity: number) => void;
};

function ProductItem({ product, quantity, onChange }: ProductItemProps) {
  return (
    <div className={styles.item}>
      <img
        className={styles.image}
        src={product.variantImage}
        alt=""
      />

      <div className={styles.info}>
        <div className={styles.name}>{product.title}</div>

        <div className={styles.row}>
          <div className={styles.price}>
            <span className={styles.currency}>¥</span>
            <span className={styles.amount}>{product.currentPriceAmount}</span>
            /袋
          </div>
          <div className={styles.choicesWrapper}>
            <div className={styles.choices}>
              <QuantitySelect
                value={quantity}
                choices={product.choices}
                onChange={(v) => onChange(product.id, v)}
                triggerClassName={styles.selectTrigger}
              />
            </div>
            <span className={styles.unit}>{product.displayUnit}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
